/**
 * Solr Provider. Works with geomer Solr Wrapper.
 *
 * @class Solr
 */
export class Solr {
  constructor (suggesterUrl, selectionURL) {
    this.settings = {
      url: 'http://dev.hw-karten.de/geocoder/api/v1/suggest',
      selectorUrl: 'http://dev.hw-karten.de/geocoder/api/v1/select',
      params: {
        q: '',
        maxResults: 5
      }
    };
  }

  getParameters (options) {
    options.lang = options.lang.toLowerCase();

    if (options.suggesterURL) {
      this.settings.url = options.suggesterURL;
    }
    if (options.selectorURL) {
      this.settings.selectorUrl = options.selectorURL;
    }

    return {
      url: this.settings.url,
      selectorUrl: this.settings.selectorUrl,
      params: {
        query: options.query,
        maxResults: options.limit || this.settings.params.maxResults,
        _: Date.now()
      }
    };
  }

  handleResponse (features) {
    // console.log('features:', features);
    if (!features.result || features.length === 0) {
      return;
    }
    return features.result.map(function (feature) {
      feature = {
        id: feature.id,
        locationType: feature.locationType,
        address: {
          name: feature.label
        },
        original: {
          formatted: feature.label
        }
      };
      return feature;
    });
  }
}
